import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDTooltip from '../../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDIconButton from '../../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon, {
  IconColor,
} from '../../../../../../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

const styles = (theme: Theme) => ({
  iconButton: {
    margin: theme.spacing(0, 0, 0, -1),
  },
});

interface IProps {
  sideMenuOpen: boolean;
  tooltipText: string;
  iconType: IconType;
  onClick: () => void;
  className?: string;
  color?: IconColor;
  disabled?: boolean;
  disabledReason?: string;
  marginTop?: any;
  classes?: any;
}

/**
 * Knappen som fäller ut sidomenyn
 */
export const EkonomiskAnalysSideMenuIconButton: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const icon = (
    <EDIcon
      iconType={props.iconType}
      color={props.color}
      marginTop={props.marginTop}
    />
  );

  if (props.sideMenuOpen) {
    return icon;
  } else {
    return (
      <EDTooltip
        placement="right"
        title={
          props.disabled && props.disabledReason == null
            ? 'Ingen analys vald'
            : props.disabled && !props.disabledReason != null
            ? props.disabledReason
            : props.tooltipText
        }
        enableClickOnTouch={props.disabled}
      >
        <EDIconButton
          disabled={props.disabled}
          disabledReason={
            props.disabled && props.disabledReason == null
              ? 'Ingen analys vald'
              : props.disabled && props.disabledReason != null
              ? props.disabledReason
              : undefined
          }
          tooltip=""
          icon={icon}
          className={props.classes.iconButton}
          onClick={props.onClick}
        />
      </EDTooltip>
    );
  }
};

export default withStyles(EkonomiskAnalysSideMenuIconButton, styles);
